/******************************************************************************
 *
 * Work Helper Functions
 *
 * Shared utility functions used across Work Execution components.
 *
 ******************************************************************************/

export function formatDate(value) {

    if (!value) {

        return "-";

    }

    try {

        return new Date(value).toLocaleString();

    }

    catch {

        return value;

    }

}


export function getStatusBadge(status) {

    switch (status) {

        case "OPEN":
            return "bg-primary";

        case "IN_PROGRESS":
            return "bg-warning text-dark";

        case "COMPLETED":
            return "bg-success";

        case "CLOSED":
            return "bg-dark";

        case "CANCELLED":
            return "bg-danger";

        default:
            return "bg-secondary";

    }

}


export function getPriorityBadge(priority) {

    switch (priority) {

        case "LOW":
            return "bg-success";

        case "MEDIUM":
            return "bg-info";

        case "HIGH":
            return "bg-warning text-dark";

        case "CRITICAL":
            return "bg-danger";

        default:
            return "bg-secondary";

    }

}


export function calculateProgress(work) {

    return work?.completion_percentage || 0;

}


export function groupAssignments(assignments = []) {

    return {

        executors: assignments.filter(

            x => x.assignment_role === "EXECUTOR"

        ),

        owners: assignments.filter(

            x => x.assignment_role === "OWNER"

        ),

        approvers: assignments.filter(

            x => x.assignment_role === "APPROVER"

        )

    };

}